import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SousCategorie } from 'app/models/sous-categorie';
import { Observable, Subject, throwError } from 'rxjs';
import { tap, catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SousCategorieService {

  base_path = 'https://app.titv-store-api.com/';

  constructor(private http: HttpClient) { }
  
  private refreshData = new Subject<void>();
  
  get refreshNedeed() {
    return this.refreshData;
  }

  // ✅ Même méthode que MagazineService
  private getToken(): string {
    try {
      const authUser = sessionStorage.getItem('auth-user');
      if (authUser) {
        const userObj = JSON.parse(authUser);
        return userObj.token || '';
      }
      return '';
    } catch {
      return '';
    }
  }

  // ✅ Même méthode que MagazineService
  private getHeaders(): HttpHeaders {
    const token = this.getToken();
    
    if (token) {
      return new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      });
    }
    
    return new HttpHeaders({
      'Content-Type': 'application/json'
    });
  }

  // ✅ Correction CRUCIALE : arrow function pour garder le contexte 'this'
  private handleError = (error: HttpErrorResponse) => {
    let errorMessage = 'Une erreur est survenue';
    
    if (error.status === 403) {
      errorMessage = `Accès interdit. Token: ${this.getToken() ? 'présent' : 'absent'}`;
    } else if (error.status === 401) {
      errorMessage = 'Non autorisé. Veuillez vous reconnecter.';
    } else {
      errorMessage = `Erreur ${error.status}: ${error.message}`;
    }
    
    console.error('Erreur SousCategorieService:', errorMessage);
    return throwError(() => new Error(errorMessage));
  }

  createSousCategorie(item: any, idProduit: any): Observable<SousCategorie> {
    const headers = this.getHeaders();
    return this.http.post<SousCategorie>(
      this.base_path + 'produits/sous/add/' + idProduit, 
      JSON.stringify(item), 
      { headers }
    ).pipe(
      tap(() => this.refreshData.next()),
      catchError(this.handleError)
    );
  }

  getSousCategorie(id: any): Observable<SousCategorie> {
    const headers = this.getHeaders();
    return this.http.get<SousCategorie>(
      this.base_path + 'produits/sous/' + id,
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }

  getListSousCategorie(): Observable<SousCategorie[]> {
    const headers = this.getHeaders();
    return this.http.get<SousCategorie[]>(
      this.base_path + 'produits/sous/all',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  updateSousCategorie(id: any, item: any): Observable<SousCategorie> {
    const headers = this.getHeaders();
    return this.http.put<SousCategorie>(
      this.base_path + 'produits/sous/update/' + id, 
      JSON.stringify(item), 
      { headers }
    ).pipe(
      tap(() => this.refreshData.next()),
      catchError(this.handleError)
    );
  }

  // In sous-categorie.service.ts
deleteSousCategorie(id: any): Observable<any> {
  const headers = this.getHeaders();
  return this.http.delete(
    this.base_path + 'produits/sous/delete/' + id,
    {
      headers,
      responseType: 'text'  // <-- important: backend returns plain text
    }
  ).pipe(
    tap(() => this.refreshData.next()),
    map(response => ({ success: true, message: response })),
    catchError(this.handleError)
  );
}

  // sous-categorie.service.ts (add this method)
updateSousCategorieOrder(id: number, displayOrder: number): Observable<any> {
  const headers = this.getHeaders();
  return this.http.put(
    this.base_path + 'produits/sous/update-order/' + id,
    displayOrder,  // backend expects Integer directly in body
    { headers, responseType: 'text' }
  ).pipe(
    tap(() => this.refreshData.next()),
    catchError(this.handleError)
  );
}
}